import { Routes } from "@angular/router";
import { Error404Component } from "./core/components/error-404/error-404.component";

export const routes: Routes = [
  { path: "home", pathMatch: "full", redirectTo: "" },
  { path: "accueil", pathMatch: "full", redirectTo: "" },

  {
    path: "blog",
    loadChildren: () =>
      import("./routes/blog/blog.module").then((mod) => mod.BlogModule),
  },
  {
    path: "contact",
    loadChildren: () =>
      import("./routes/contact/contact.module").then(
        (mod) => mod.ContactModule,
      ),
  },
  {
    path: "location",
    loadChildren: () =>
      import("./routes/catalog/catalog.module").then(
        (mod) => mod.CatalogModule,
      ),
  },
  {
    path: "legal",
    loadChildren: () =>
      import("./routes/legal/legal.module").then((mod) => mod.LegalModule),
  },
  {
    path: "404",
    component: Error404Component,
  },

  {
    path: "",
    pathMatch: "full",
    loadChildren: () =>
      import("./routes/home/home.module").then((mod) => mod.HomeModule),
  },

  { path: "**", redirectTo: "location" },
];
